const actionDesktop = new URL("./desktop/action.webp", import.meta.url).href;
const dedicationDesktop = new URL("./desktop/dedication.webp", import.meta.url).href;
const firstDesktop = new URL("./desktop/first.webp", import.meta.url).href;
const introDesktop = new URL("./desktop/intro.webp", import.meta.url).href;
const jiaxingDesktop = new URL("./desktop/jiaxing.webp", import.meta.url).href;
const questionDesktop = new URL("./desktop/question.webp", import.meta.url).href;
const reflectionDesktop = new URL("./desktop/reflection.webp", import.meta.url).href;
const struggleDesktop = new URL("./desktop/struggle.webp", import.meta.url).href;
const ticketDesktop = new URL("./desktop/ticket.webp", import.meta.url).href;
const actionMobile = new URL("./mobile/action.webp", import.meta.url).href;
const dedicationMobile = new URL("./mobile/dedication.webp", import.meta.url).href;
const firstMobile = new URL("./mobile/first.webp", import.meta.url).href;
const introMobile = new URL("./mobile/intro.webp", import.meta.url).href;
const jiaxingMobile = new URL("./mobile/jiaxing.webp", import.meta.url).href;
const reflectionMobile = new URL("./mobile/reflection.webp", import.meta.url).href;
const struggleMobile = new URL("./mobile/struggle.webp", import.meta.url).href;
const ticketMobile = new URL("./mobile/ticket.webp", import.meta.url).href;

export type SceneVisualKey = "intro" | "question" | "first" | "struggle" | "dedication" | "reflection" | "jiaxing" | "action" | "ticket";

export type SceneVisualAsset = {
  desktop: string;
  mobile: string;
  desktopPosition: string;
  mobilePosition: string;
};

export type SceneVisualManifest = Record<SceneVisualKey, SceneVisualAsset>;

export const sceneVisualManifest: SceneVisualManifest = {
  intro: { desktop: introDesktop, mobile: introMobile, desktopPosition: "center center", mobilePosition: "center center" },
  question: { desktop: questionDesktop, mobile: introMobile, desktopPosition: "center center", mobilePosition: "center center" },
  first: { desktop: firstDesktop, mobile: firstMobile, desktopPosition: "center center", mobilePosition: "center center" },
  struggle: { desktop: struggleDesktop, mobile: struggleMobile, desktopPosition: "center center", mobilePosition: "center center" },
  dedication: { desktop: dedicationDesktop, mobile: dedicationMobile, desktopPosition: "center center", mobilePosition: "center center" },
  reflection: { desktop: reflectionDesktop, mobile: reflectionMobile, desktopPosition: "center center", mobilePosition: "center center" },
  jiaxing: { desktop: jiaxingDesktop, mobile: jiaxingMobile, desktopPosition: "center center", mobilePosition: "center center" },
  action: { desktop: actionDesktop, mobile: actionMobile, desktopPosition: "center center", mobilePosition: "center center" },
  ticket: { desktop: ticketDesktop, mobile: ticketMobile, desktopPosition: "center center", mobilePosition: "center center" },
};

export const ticketExportBase = ticketMobile;
